import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
    selector: 'app-product-image',
    templateUrl: './product-image.component.html',
    styleUrls: ['./product-image.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductImageComponent {
    @Input() imageUrl: string;
    @Input() packSize: string;
    @Input() capacity: string;
    @Input() discountPercentage: number;
    @Input() isNewProduct: boolean;
    @Input() maxHeightImage: boolean;
    @Input() brandImage: boolean;

    constructor() { }

    showOnError(){
        this.imageUrl = "https://sgresources.supergrp.net/SGConvenience/Wholesale/Brand/NoImage.png";
    }
}
